/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Reserve_OneInputs */

const fr_extra_session_reserve_one = /** @type {(inputs: Extra_Session_Reserve_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dont 1 séance achetée en réserve`)
};

/**

* @param {Extra_Session_Reserve_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_reserve_one = /** @type {((inputs?: Extra_Session_Reserve_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Reserve_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_reserve_one(inputs)
});